import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-travel',
    templateUrl: './travel.component.html',
    styleUrls: ['./travel.component.scss'],
    standalone: false
})
export class TravelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
